import { RouterView } from 'vue-router'

export const storefrontRoutes = [
  {
    path: '/online-shop',
    component: RouterView,
    children: [
      {
        name: 'storefrontSettings',
        path: 'settings',
        component: () => import('@/modules/storefront/views/StorefrontSettingsView.vue'),
        meta: {
          locationTypes: ['location', 'singleLocation']
        }
      }
    ]
  }
]
